import React from "react";

import { LoadingOutlined } from "@ant-design/icons";

import "./TemplateSectionLoading.css";

const loadingIcon = <LoadingOutlined spin className="TemplateSectionLoading__Icon" aria-hidden />;

/**
 * Reusable loading indicator for template module sections.
 * @param {"inline"|"spinner"|"overlay"|"fullscreen"} variant
 */
export default function TemplateSectionLoading({
  className = "",
  variant = "spinner",
  greyout = false,
}) {
  if (variant === "inline") {
    return (
      <div className={`TemplateSectionLoading TemplateSectionLoading--inline ${className}`}>
        {loadingIcon}
      </div>
    );
  }

  if (variant === "overlay") {
    return (
      <div className={`TemplateSectionLoading TemplateSectionLoading--overlay ${greyout ? "TemplateSectionLoading--greyout" : ""} ${className}`}>
        {loadingIcon}
      </div>
    );
  }

  if (variant === "fullscreen") {
    return (
      <div className={`TemplateSectionLoading TemplateSectionLoading--fullscreen ${greyout ? "TemplateSectionLoading--greyout" : ""} ${className}`}>
        {loadingIcon}
      </div>
    );
  }

  return (
    <div className={`TemplateSectionLoading ${className}`}>
      {loadingIcon}
    </div>
  );
}
